import i, { forwardRef as p } from "react";
import { cls as f } from "../../helpers/cls.js";
import { forwardAsTagRef as S } from "../../helpers/forwardAsTagRef.js";
import { Flex as b } from "../Flex/Flex.js";
import { Text as m } from "../Text/Text.js";
var g = Object.defineProperty,
  D = Object.defineProperties,
  w = Object.getOwnPropertyDescriptors,
  l = Object.getOwnPropertySymbols,
  u = Object.prototype.hasOwnProperty,
  v = Object.prototype.propertyIsEnumerable,
  y = (r, a, e) => a in r ? g(r, a, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : r[a] = e,
  d = (r, a) => {
    for (var e in a || (a = {})) u.call(a, e) && y(r, e, a[e]);
    if (l) for (var e of l(a)) v.call(a, e) && y(r, e, a[e]);
    return r;
  },
  x = (r, a) => D(r, w(a)),
  c = (r, a) => {
    var e = {};
    for (var t in r) u.call(r, t) && a.indexOf(t) < 0 && (e[t] = r[t]);
    if (r != null && l) for (var t of l(r)) a.indexOf(t) < 0 && v.call(r, t) && (e[t] = r[t]);
    return e;
  };
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const _ = p((r, a) => {
  var e = r,
    {
      variant: t = "title-medium"
    } = e,
    n = c(e, ["variant"]);
  const o = t === "title-medium" ? m.TitleMedium : m.BodyLarge;
  return i.createElement(o, d({
    "data-ds-component": "DS-Card-Title",
    ref: a
  }, n));
});
_.displayName = "CardTitle";
const E = p((r, a) => {
  var e = r,
    {
      variant: t = "body-medium"
    } = e,
    n = c(e, ["variant"]);
  const o = t === "body-medium" ? m.BodyMedium : m.BodySmall;
  return i.createElement(o, d({
    "data-ds-component": "DS-Card-Description",
    ref: a
  }, n));
});
E.displayName = "CardDescription";
const O = p((r, a) => {
  var e = r,
    {
      sources: t,
      alt: n
    } = e,
    o = c(e, ["sources", "alt"]);
  return i.createElement("picture", {
    className: "olx-card-image"
  }, t.map((s, N) => i.createElement("source", d({
    key: s.srcSet
  }, t[N]))), i.createElement("img", x(d({
    "data-ds-component": "DS-Card-Image"
  }, o), {
    alt: n,
    ref: a,
    className: f("olx-card-image__img", o.className)
  })));
});
O.displayName = "CardImage";
const C = S((r, a) => {
  const e = r,
    {
      className: t,
      children: n,
      variant: o
    } = e,
    s = c(e, ["className", "children", "variant"]);
  return i.createElement(b, d({
    className: f({
      "olx-card": !0,
      ["olx-card--".concat(o)]: o
    }, t),
    "data-ds-component": "DS-Card",
    ref: a
  }, s), n);
});
C.displayName = "Card";
export { C as Card, E as CardDescription, O as CardImage, _ as CardTitle };